import { z } from 'zod';
import isMobilePhone from 'validator/lib/isMobilePhone';

const createRefinedSchema = (predicate, message, t) =>
  z
    .string({
      message: t('auth.required_field'),
    })
    .refine(predicate, { message });

const createRefinedSchemaWithBoolean = (predicate, message) =>
  z.boolean().refine(predicate, { message });

const validatePhoneNumber = (val) => {
  const phoneNumber = val.replace(/[()+-]/g, '');
  return isMobilePhone(phoneNumber);
};

const validateTerms = (val) => val === true;

const termsSchema = (t) =>
  createRefinedSchemaWithBoolean(validateTerms, t('auth.required_field'));

const legalAgeSchema = (t) =>
  createRefinedSchemaWithBoolean(validateTerms, t('auth.required_field'));

const passswordSchema = (t) =>
  z
    .string({
      message: t('auth.required_field'),
    })
    .min(8, t('auth.login.password.error_min'))
    .refine((password) => /[a-zA-Z]/.test(password), {
      message: t('auth.login.password.error_letter'),
      path: ['password'],
    })
    .refine((password) => /\d/.test(password), {
      message: t('auth.login.password.error_number'),
      path: ['password'],
    });

export const phoneFormSchemaWithAuth = (t) =>
  z.object({
    phone: createRefinedSchema(
      validatePhoneNumber,
      t('auth.login.phone.error_invalid'),
      t
    ),
    password: z.string({
      message: t('auth.required_field'),
    }),
  });

export const phoneFormSchemaWithRegistration = (t) =>
  z.object({
    phone: createRefinedSchema(
      validatePhoneNumber,
      t('auth.login.phone.error_invalid'),
      t
    ),
    isLegalAge: legalAgeSchema(t),
    password: passswordSchema(t),
    // isTerms: termsSchema(t),
    isNews: z.boolean().optional(),
  });

export const emailFormSchemaWithRegistration = (t) =>
  z.object({
    email: z
      .string({
        message: t('auth.required_field'),
      })
      .email(t('auth.login.email.error_invalid')),
    password: passswordSchema(t),
    isLegalAge: legalAgeSchema(t),
    // isTerms: termsSchema(t),
    isNews: z.boolean().optional(),
  });

export const emailFormSchemaWithAuth = (t) =>
  z.object({
    email: z
      .string({
        message: t('auth.required_field'),
      })
      .email(t('auth.login.email.error_invalid')),
    password: z.string({
      message: t('auth.required_field'),
    }),
  });

export const resetPasswordWithPhoneSchema = (t) =>
  z.object({
    phone: createRefinedSchema(
      validatePhoneNumber,
      t('auth.login.phone.error_invalid'),
      t
    ),
  });

export const resetPasswordWithEmailSchema = (t) =>
  z.object({
    email: z
      .string({
        message: t('auth.required_field'),
      })
      .email(t('auth.login.email.error_invalid')),
  });

export const createPasswordSchema = (t) =>
  z
    .object({
      password: passswordSchema(t),
      confirmPassword: passswordSchema(t),
    })
    .refine(
      (data) => {
        return data.password === data.confirmPassword;
      },
      {
        message: t('auth.recover.password.error_match'),
        path: ['confirmPassword'],
      }
    );

export const SmsConfirmSchema = z.string().length(1);
